<template>
  <div
    style="background: black"
    :class="{ debug: debug }"
    :style="{
      top: marginVertical + 'px ',
      bottom: marginVertical + 'px ',
      left: +marginHorizontal + 'px',
      right: +marginHorizontal + 'px'
    }"
  >
    <warning-message
      v-if="!screen.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <warning-message
      v-else-if="todaysNowPlayingAndUpcomingShowings.length == 0"
    >
      {{ $t('showing.noShowingsToday') }}
    </warning-message>
    <div v-else-if="screen && currentShowing">
      <!-- We have a movie and showtimes-->
      <div
        style="height: 100vh; overflow: hidden;"
        class="row"
      >
        <div
          class="col-auto z-top"
          :class="hasScreenNameOnDisplay && !isTwoWordsScreenName ? 'row' : undefined"
        >
          <div
            v-if="hasScreenNameOnDisplay && !isTwoWordsScreenName "
            class="col-auto"
            style="width: 6.5vw; position: relative;"
          >
            <div
              class="text-center text-white text-uppercase absolute z-max"
              style="font-weight: 800; line-height: 6.5vw; transform: rotate(270deg) translate(-45vh, -45vh); width: 100vh; text-wrap: nowrap;"
              :style="{ 'font-size': currentShowing.screen.name.split(' ').length > 1 ? '5vw' : '6vw' }"
            >
              {{ currentShowing.screen.name }}
            </div>
          </div>
          <img
            class="col"
            style="height: 100vh;"
            :src="currentShowingImageUrl"
          >
        </div>
        <div class="col">
          <div
            class="column"
            :class="showLogo ? 'justify-between' : 'justify-around' "
            style="height: 100vh; padding: 3vh;"
          >
            <div
              v-if="showLogo"
              class="row justify-end items-center col-auto"
            >
              <div
                class="col text-left"
                style="min-height: 10vh; padding-left: 2vw"
              >
                <img
                  :src="currentSite.lightLogoImageUrl"
                  style="height: 9vh;"
                >
              </div>
            </div>

            <div class="row column justify-center col">
              <div
                v-if="showMovieName"
                class="text-left text-white text-bold ellipsis-3-lines"
                style="line-height: 1.2; padding-left: 2vw; margin-bottom: 1vh;"
                :style="fontSize"
              >
                {{ currentShowing.movie.name }}
              </div>
              <div
                class="row justify-start items-center q-gutter-sm text-white text-left"
                style="padding-left: 2vw"
              >
                <template v-if="currentSite.signageConfig.display_rating">
                  <rated
                    v-if="currentShowing.movie.rating"
                    :rated="currentShowing.movie.rating"
                    :rating-reason="currentShowing.movie.ratingReason"
                    :outline="false"
                    color="white"
                    text-color="dark"
                    size="2vw"
                    :no-margin="false"
                    :highlight-r-rated="highlightRRated"
                    :disable-official-symbol="disableOfficialSymbol"
                    class="text-bold q-px-lg q-py-lg col-auto"
                  />
                  <q-chip
                    v-if="showRatingReason && currentShowing.movie.ratingReason"
                    class="text-bold q-pa-sm col-auto"
                    square
                    color="transparent"
                    text-color="white"
                    size="2.2vw"
                    dense
                    style="border: solid 2px;"
                  >
                    <div style="white-space: normal; font-size: 1.3vw; line-height: 1;">
                      {{ currentShowing.movie.ratingReason }}
                    </div>
                  </q-chip>
                </template>
                <template v-if="showShowingBadges">
                  <showing-badge
                    v-for="showingBadge in currentShowing.showingBadges.data"
                    :key="showingBadge.id"
                    size="2vw"
                    :showing-badge="showingBadge"
                    color="white"
                  />
                </template>
              </div>
            </div>
            <div class="row justify-around items-center col-auto">
              <template v-if="showScreenName">
                <div
                  v-if="isTwoWordsScreenName"
                  class="col-auto relative-position"
                  style="padding-left: 2vw; margin-left: 2vw;"
                >
                  <div
                    class="text-center absolute text-white text-bold text-uppercase"
                    style="font-size: 3.1vw; line-height: 1.1; padding-bottom: 2vw; transform: rotate(270deg) translate(-45%, -100%);"
                  >
                    {{ screenNameFirstWord }}
                  </div>
                  <div
                    class="text-left text-white text-uppercase"
                    style="font-weight: 800; font-size: 17vw; line-height: 1; margin-left: 2vh; min-width: 15vw;"
                    :style="{ 'font-size': screenNameSecondWord.length > 4 ? '9vw' : '17vw' }"
                  >
                    {{ screenNameSecondWord }}
                  </div>
                </div>
              </template>
              <div
                class="col column justify-starts self-center"
                :style="{ 'padding-left': showScreenName && isTwoWordsScreenName ? '' : '2vw' }"
              >
                <div
                  class="col text-left text-white text-uppercase"
                  style="font-weight: 800; font-size: 5vw; line-height: 1;"
                  :style="{ 'margin-top': showScreenName && isTwoWordsScreenName ? '' : '8vw' }"
                >
                  {{ currentShowing.siteTime.format('h:mm a') }}
                </div>
                <div
                  class="col text-left text-grey text-uppercase text-italic"
                  style="font-weight: 800; font-size: 2vw;"
                >
                  Ends {{ currentShowing.siteEndTime.format("h:mm a") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      An error occurred
    </warning-message>
    <warning-message
      v-else-if="!screen"
    >
      {{ `Unknown Screen - ${$route.params && $route.params.screenId}` }}
    </warning-message>
    <warning-message
      v-else
    >
      Unknown Error
    </warning-message>
  </div>
</template>

<script>
import { imgixHost } from 'src/config'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import CurrentShowingsSignageMixin from 'src/modules/signage/mixins/CurrentShowingsSignageMixin'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'ScreenLandscapePosterLeft',
  components: {
    ShowingBadge,
    Rated,
    WarningMessage
  },
  mixins: [CurrentShowingsSignageMixin, ShowingsSignageConfigurationMixin],
  props: {
    screenId: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return route?.params?.screenId
      }
    },
    showScreenName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-screen-name'] === 'false')
      }
    },
    showMovieName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-movie-name'] === 'false')
      }
    },
    showShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-showing-badges'] === 'false')
      }
    },
    showRatingReason: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-rating-reason'] === 'false')
      }
    }
  },
  data () {
    return {
      errorOccurred: false
    }
  },
  models: {
    screen: {
      fields: ['id', 'name', 'color'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default',
        withinSignageThreshold: true
      },
      variables () {
        return {
          id: this.screenId
        }
      },
      immediate: true
    }
  },
  computed: {
    currentShowingImageUrl () {
      return `${imgixHost}/${this.currentShowing.movie.posterImage}` + '?fit=fit&fm=jpeg&auto=format&cs=origin&w=' + (this.$q.screen.width / 10) * 4 + '&h=' + this.$q.screen.height
    },
    hasScreenNameOnDisplay () {
      if (!this.currentShowing.screen.name) return
      return this.showScreenName && this.currentShowing.screen.name
    },
    isTwoWordsScreenName () {
      if (!this.currentShowing.screen.name) return
      return this.currentShowing.screen.name.split(' ').length === 2
    },
    screenNameFirstWord () {
      if (!this.currentShowing.screen.name) return
      return this.currentShowing.screen.name.split(' ')[0]
    },
    screenNameSecondWord () {
      if (!this.currentShowing.screen.name) return
      return this.currentShowing.screen.name.split(' ')[1]
    },
    fontSize () {
      const movieNameLetterCount = this.currentShowing.movie.name.length

      if (movieNameLetterCount > 50) {
        return 'font-size : 3.8vw'
      } else if (movieNameLetterCount > 20) {
        return 'font-size : 5vw'
      } else {
        return 'font-size : 6vw'
      }
    }
  },
  async mounted () {
    // Fetching the screen when in the app mode of digital-signage, sets the site_id cookie
    // This will reload the configuration data after being authenticated
    this.$handleAuthChange()
  }
}
</script>

<style scoped>

.debug .poster-and-showings-container > div {
  border: solid 1px red;
}

.main-display {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
}

.site-logo {
  max-width: 50vw;
  max-height: 10vh;
}

</style>
